import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import AssistantPage from "../pages/assistant/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/assistant",
    element: <AssistantPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
